// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editable-a[data-v-11337786]{border-bottom:1px dotted #000}.icon-black[data-v-11337786]{color:#000}", "",{"version":3,"sources":["webpack://./src/components/Inputs/InputEditable.vue"],"names":[],"mappings":"AACA,6BACE,6BAAA,CAGF,6BACE,UAAA","sourcesContent":["\n.editable-a {\n  border-bottom: 1px dotted #000;\n}\n\n.icon-black {\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
